import DepositACheckPage, { getDefaultPageUI } from "components/pages/DepositACheckPage";

export default function CaptureMabiDepositsSelectAccount(props){
    const ui = getDefaultPageUI();
    ui.accountDropdown.isOpen = true;

    return <DepositACheckPage ui={ ui } />
}